import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { computed, ref } from 'vue';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import CarouselPageNav from '@/sections/CarouselPageNav.vue';
import GridCardSectionCard from './GridCardSectionCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GridCardSectionMobile',
  props: {
    cards: {},
    isCarousel: { type: Boolean },
    mobileCardsPerPage: {},
    instanceKey: {}
  },
  setup(__props: any) {

const props = __props;

const modules = [Navigation, Pagination];
const activeIndex = ref(0);

const navigation = computed(() => ({
  prevEl: `.gcs-mobile-prev-${props.instanceKey}`,
  nextEl: `.gcs-mobile-next-${props.instanceKey}`,
}));

const pagination = computed(() => ({
  el: `.gcs-mobile-pagination-${props.instanceKey}`,
  clickable: true,
  bulletClass: 'gcs-swiper-dot',
  bulletActiveClass: 'is-active',
}));

const showNav = computed(() => props.cards.length > props.mobileCardsPerPage);

const onSlideChange = (swiper: any) => {
  activeIndex.value = swiper?.activeIndex || 0;
};

const isActiveVisible = (idx: number) =>
  idx >= activeIndex.value && idx < activeIndex.value + props.mobileCardsPerPage;

return (_ctx: any,_cache: any) => {
  return (!__props.isCarousel)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.$style['c-grid-card-section-mobile__stack'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, index) => {
          return (_openBlock(), _createBlock(GridCardSectionCard, {
            key: card.id || `mobile-card-${index}`,
            card: card
          }, null, 8, ["card"]))
        }), 128))
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.$style['c-grid-card-section-mobile__carousel'])
      }, [
        _createVNode(_unref(Swiper), {
          modules: modules,
          "slides-per-view": __props.mobileCardsPerPage,
          "space-between": 8,
          navigation: navigation.value,
          pagination: pagination.value,
          onSlideChange: onSlideChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                key: card.id || `mobile-slide-${index}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
            _ctx.$style['c-grid-card-section-mobile__slide'],
            isActiveVisible(index) ? _ctx.$style['is-active'] : _ctx.$style['is-inactive'],
          ])
                  }, [
                    _createVNode(GridCardSectionCard, { card: card }, null, 8, ["card"])
                  ], 2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["slides-per-view", "navigation", "pagination"]),
        _createVNode(CarouselPageNav, {
          show: showNav.value,
          "prev-class": `gcs-mobile-prev-${__props.instanceKey}`,
          "next-class": `gcs-mobile-next-${__props.instanceKey}`,
          "pagination-class": `gcs-mobile-pagination-${__props.instanceKey}`
        }, null, 8, ["show", "prev-class", "next-class", "pagination-class"])
      ], 2))
}
}

})